// extracted by mini-css-extract-plugin
export default {"slide":"TVCardMediaCarousel_slide__MgaIY","img":"TVCardMediaCarousel_img__ib0QI","video":"TVCardMediaCarousel_video__QMUNf","listItem":"TVCardMediaCarousel_listItem__6oIlA"};